module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headertoc01",
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', {
    attrs: {
      "id": "headertoc01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vi",
      "epub:type": "pagebreak",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vii",
      "epub:type": "pagebreak",
      "id": "pvii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chidunbarhester0007#pref"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chidunbarhester0008#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chidunbarhester0009#ch01"
    }
  }, [_vm._v("1: Precariously Perched in a Port")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chidunbarhester0010#ch02"
    }
  }, [_vm._v("2: Yes, We Have No Bananas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chidunbarhester0011#ch03"
    }
  }, [_vm._v("3: Coastal Translocations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chidunbarhester0012#ch04"
    }
  }, [_vm._v("4: Aqua Nullius")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chidunbarhester0013#conc"
    }
  }, [_vm._v("Conclusion: Flux: Bridging to Futures")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chidunbarhester0014#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chidunbarhester0015#app"
    }
  }, [_vm._v("Appendix: Timeline of Legislation and Events")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chidunbarhester0016#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chidunbarhester0018#biblio"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chidunbarhester0019#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3713805e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-dunbar-hester-0006.vue
// module id = 69
// module chunks = 0